import { Component, Input, OnInit } from '@angular/core';

/**
 * Componente indicador de carga (spinner) que puede mostrarse en variante
 * blanca según el valor de `blanco`.
 */
@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.css']
})
export class LoaderComponent implements OnInit {
  @Input() blanco: boolean = false;
  constructor() { }

  ngOnInit(): void {
  }

}
